import { Layout } from '@/modules/shared/layouts/layout'

import { useHome } from '../hooks/use-home.hook'
import { HomeInterface } from '../interfaces/home.interface'
export function HomeContainer() {
  const homeController = useHome()

  return (
    <Layout hasSellerFilter pageTitle="Início" isDrawer>
      <HomeInterface {...homeController} />
    </Layout>
  )
}
